import axios from 'axios';
import {API_URL_PREFIX, axiosAuthHeader, axiosErrorHandler} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/acts';

class ActsService {
    // no header needed
    getActs(search, type, slot) {
        let url = API_URL + "?offset=0&limit=100&include_total=true&order_by=%2Dupdated_time";
        if (search != null && search !== "") {
            url += "&search=" + search;
        }
        if (type != null && type !== "") {
            url += "&type=" + type;
        }
        if (slot != null && slot !== "") {
            url += "&s_preferred_slots__ilike=%" + slot + "%";
        }
        return axios.get(url).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    getUnmatchedActs(venue_id, slot_def) {
        let url = API_URL + "/unmatched?venue_id=" + venue_id + "&slot_def=" + slot_def;
        return axios.get(url).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // no header needed
    getActById(act_id) {
        return axios.get(API_URL + "/" + act_id).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // no header needed
    getActsByCreator(user_id) {
        return axios.get(API_URL + "?offset=0&limit=100&include_total=true&order_by=%2Dupdated_time&creator_id=" + user_id).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    updateAct(act_id, payload) {
        return axios.patch(API_URL + "/" + act_id, payload, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    createAct(payload) {
        return axios.post(API_URL, payload, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    deleteAct(act_id) {
        return axios.delete(API_URL + "/" + act_id, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }
}

export default new ActsService();
